module.exports = __webpack_public_path__ + "img/webpieces.b9152eb9.webp";